<script setup lang="ts">
import ReportReadingsTable from './ReportReadingsTable.vue'
import ReportReadingsChart from './ReportReadingsChart.vue'
import { useCabinetReports } from '@/pages/object/CabinetReports'

const report = useCabinetReports()
</script>

<template>
  <ReportReadingsChart v-if="report.contentType == 'chart'" />
  <ReportReadingsTable v-else />
</template>
